__turbopack_context__.v({
  "container": "NewThreatResearch-module-scss-module__QBJj_a__container",
  "seeAll": "NewThreatResearch-module-scss-module__QBJj_a__seeAll",
  "threatResearch": "NewThreatResearch-module-scss-module__QBJj_a__threatResearch",
});
